import styled from 'styled-components';

export const DrawerAdjustment = styled.div`
    padding-left: 72px;
    text-align: center;
    @media screen and (max-width: 700px) {
        padding-left: 0;
    }
`;
